import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

export function useFindActiveExperiment(productRefId: string | undefined) {
  const { activeExperiments } = useSelector((state: RootState) => state.experimentsReducer.global);
  return activeExperiments.find((activeExperiment) => activeExperiment.product?.refId === productRefId);
}
